/* ============================================================================
   ASTR v5 — shared behaviour for the v2 concept design.
   - astrToast(msg): dark bottom-center toast
   - add-to-bag line total: "Add to bag — ₹1,798" updates with qty/variant
   Section-specific JS (dock logo, peacock menu) lives inside its section file.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- toast ------------------------------------------------------------- */
  var toastEl = null;
  var toastTimer = null;

  function astrToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'astr-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-on');
    }, 2200);
  }
  window.astrToast = astrToast;

  /* ---- money formatting (uses shop money format when exposed) ------------ */
  function formatMoney(cents) {
    var amount = cents / 100;
    var formatted;
    try {
      formatted = amount.toLocaleString('en-IN', {
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      });
    } catch (e) {
      formatted = String(Math.round(amount));
    }
    return '₹' + formatted; /* ₹ */
  }
  window.astrFormatMoney = formatMoney;

  /* ---- add-to-bag line total ---------------------------------------------
     Any element with [data-astr-line-total] inside a product form shows
     unit price × qty. Unit price comes from [data-astr-unit-price] (cents),
     kept current by Ecomus variant-change events re-rendering the form. */
  function updateLineTotals(root) {
    (root || document).querySelectorAll('[data-astr-line-total]').forEach(function (el) {
      var form = el.closest('form, product-form, .hdt-product-form, [data-astr-product-form]') || document;
      var priceHolder = form.querySelector('[data-astr-unit-price]') ||
        document.querySelector('[data-astr-unit-price]');
      if (!priceHolder) return;
      var unit = parseInt(priceHolder.getAttribute('data-astr-unit-price'), 10);
      if (isNaN(unit)) return;
      var qtyInput = form.querySelector('input[name="quantity"]') ||
        document.querySelector('input[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      el.textContent = formatMoney(unit * qty);
    });
  }
  window.astrUpdateLineTotals = updateLineTotals;

  document.addEventListener('change', function (e) {
    if (e.target && (e.target.name === 'quantity' || e.target.name === 'id' || e.target.closest('[data-astr-product-form], .hdt-product-form, product-form'))) {
      updateLineTotals();
    }
  });
  document.addEventListener('click', function (e) {
    /* qty steppers mutate the input without a change event in some builds */
    if (e.target.closest('[name="plus"], [name="minus"], .hdt-quantity button, quantity-input button')) {
      setTimeout(updateLineTotals, 50);
    }
  });
  /* variant price re-renders: observe the unit-price holder for attr swaps */
  document.addEventListener('DOMContentLoaded', function () {
    updateLineTotals();
    var holder = document.querySelector('[data-astr-unit-price]');
    if (holder && window.MutationObserver) {
      new MutationObserver(function () { updateLineTotals(); })
        .observe(holder, { attributes: true, attributeFilter: ['data-astr-unit-price'] });
    }
  });
})();
